import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import reduxThunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import { appReducer } from './reducers';
import formReducer from '../components/forms/reducer';
import {createResponsiveStateReducer,responsiveStoreEnhancer} from 'redux-responsive'


const middleware = [ reduxThunk ];
if (process.env.NODE_ENV !== 'production') {
    //middleware.push(createLogger());
    let redux_logger = require('redux-logger').createLogger
    middleware.push(redux_logger());
}

const configureStore = () => {

    const store = createStore(
        combineReducers({
            app: appReducer,
            forms: formReducer,
            browser: createResponsiveStateReducer({
                ultraSmall: 320,
                extraSmall: 480,
                small: 700,
                medium: 1000,
                large: 1280,
                extraLarge: 1400,
                ultraLarge: 1920,
            }),
        }),
        {},
        compose(
            responsiveStoreEnhancer,
            applyMiddleware(...middleware)
        )
    );

    if (process.env.NODE_ENV !== "production") {
        if (module.hot) {
            module.hot.accept('./reducers', () => {
                store.replaceReducer(appReducer)
            })
        }
    }

    return store
}

export default configureStore




// WEBPACK FOOTER //
// ./src/store/index.js